import React from "react";
 const Home = () => (
      <h1>404</h1>
    );

export default Home;